import React from 'react';
import AppRoutes from '../routes';
import '../css/App.css';
import { HelmetProvider } from 'react-helmet-async';


const App = () => {
  return (
    <div id="app">
      <HelmetProvider>
        <AppRoutes />
      </HelmetProvider>
    </div>
  );
};

export default App;